<template>
  <div>
    <div v-for="(registration, index) in registrationsList" :key="index" class="dea-event-wrapper">
      <CardEvent
        :card-layout="getCurrentLayout(index)"
        :event="registration.linked_event"
        :legs="registration.linked_event.legs"
        :registration="registration"
        :has-mobile-accordion="hasMobileAccordion"
        columns
      ></CardEvent>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardEvent from "@/components/patterns/CardEvent";

export default {
  name: "Registrations",
  components: { CardEvent },
  props: {
    registrations: {
      type: Array,
      required: true,
    },
    hasMobileAccordion: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["activeRegistrationIndex", "legSelectRegistrationIndex"]),
    singleRegistrationView() {
      return this.$route && this.$route.params && Object.keys(this.$route.params).indexOf("registration") > -1;
    },
    registrationsList() {
      if (this.registrations && this.registrations.length) {
        return this.registrations.filter(registration => {
          return (
            registration && registration.linked_event && (!registration.is_bundle_child || this.singleRegistrationView)
          );
        });
      }
      return [];
    },
  },
  methods: {
    getCurrentLayout(index) {
      if (
        this.activeRegistrationIndex === null &&
        (this.legSelectRegistrationIndex === null || this.legSelectRegistrationIndex === -1)
      ) {
        return "shoppingCart";
      }
      if (index === this.activeRegistrationIndex || index === this.legSelectRegistrationIndex) {
        return "active";
      }
      return "disabled";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-event-wrapper {
  margin-bottom: $space-small;
}
</style>
